import type { ReactNode } from "react";

import classNames from "classnames";
import { XLg } from "react-bootstrap-icons";

import Button from "@/components/ui/buttons/button";

import styles from "./TopBanner.module.scss";

export interface ITopBannerProps {
  children: ReactNode;
  onClose?: () => void;
}

function TopBanner({ children, onClose }: ITopBannerProps) {
  return (
    <div className={classNames("d-flex bg-body border-bottom")}>
      <div className={styles.spacer} />
      <div
        className={classNames(
          styles.content,
          "flex-grow-1 d-flex align-items-start align-items-lg-center justify-content-between gap-3"
        )}
      >
        {children}

        {onClose && (
          <Button
            variant="link"
            className="p-0 text-body me-lg-2"
            onClick={onClose}
          >
            <XLg size={14} />
          </Button>
        )}
      </div>
    </div>
  );
}

export default TopBanner;
